import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import Share from '../../template/Share/Share';
import Guide from '../../template/Share/Guide';
import AXIOS from '../../api/axios';
import { parseQuery } from '../../utils/tools';
import weixinConfig from '../../utils/weixinConfig'

const queryPara = parseQuery(window.location.search.slice(1));


class SharePage extends Component {
    constructor(props){
        super(props);
        this.state = {
            courseDetailGroupMpPhoto:'',
            audioUrl:'',
            stuEnName:'',
            stuPortrait:'',
            courseDetailEnName:'',
            guide:Boolean(queryPara.guide)
        }; 
        this.showGuide = this.showGuide.bind(this);
        this.hideGuide = this.hideGuide.bind(this);
        this.handlePush = this.handlePush.bind(this);
    }
    hideGuide(){
        this.setState({
            guide:false
        })
    }
    showGuide(){
        this.setState({
            guide:true
        })
    }
    handlePush(classSchId){
        window.location.replace(window.location.origin+window.location.pathname+`?stuId=${queryPara.stuId}&classSchId=${classSchId}`)
    }
    componentDidMount(){
        const _this = this;
        AXIOS.getStuHomeworkSingle({data:{stuId:queryPara.stuId,classSchId:queryPara.classSchId}},function(res,err){
            if(err) console.log('err',err);
            else{
                _this.setState({
                    courseDetailGroupMpPhoto:res.courseDetailCoverHPhoto,
                    audioUrl:res.url,
                    stuEnName:res.stuEnName,
                    stuPortrait:res.stuPortrait,
                    courseDetailEnName:res.courseDetailEnName
                });
                const wxConfig = {
                    title:`快来围观我的英语秀《${res.courseDetailEnName}》！`,
                    desc:'只用哈佛外教的英语课，上完一节就停不下来！',
                    link:encodeURI(`${window.location.origin}/pay/share?stuId=${queryPara.stuId}&classSchId=${queryPara.classSchId}`),
                    imgUrl:res.courseDetailCoverHPhoto
                }
                weixinConfig(wxConfig,() => {
                    this.setState({guide:false})
                });
            }
        })
        AXIOS.getStuHomeworkList({data:{stuId:queryPara.stuId,classSchId:queryPara.classSchId,num:1,row:4}},function(res,err){
            if(err) console.log('err',err);
            else{
                _this.setState({
                    list:res
                })
            }
        })
    }
    render(){
        return(
            <DocumentTitle title={`快来围观我的英语秀《${this.state.courseDetailEnName}》！`}>
                <React.Fragment>
                    <Share {...this.state} handleClick={this.showGuide}  handlePush={this.handlePush}/>
                    {this.state.guide &&
                        <Guide handleClick={this.hideGuide}/>
                    }
                </React.Fragment>
            </DocumentTitle>
        )
    }
}

export default SharePage;



// WEBPACK FOOTER //
// ./src/components/sharePage/SharePage.jsx